import { render, staticRenderFns } from "./rawMterial.vue?vue&type=template&id=74f18a11&scoped=true&"
import script from "./rawMterial.vue?vue&type=script&lang=js&"
export * from "./rawMterial.vue?vue&type=script&lang=js&"
import style0 from "./rawMterial.vue?vue&type=style&index=0&id=74f18a11&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f18a11",
  null
  
)

export default component.exports